module.exports = "/assets/data/f88f20beb6b57063ea63a522e94a5928-BS7.data.json";